import React from 'react';
import { cleanLinkSrc } from '../../../components/Viewer/useHandlers';
import { EXTENSION_TYPE_NAME } from '../constants';
import { useWidth } from '../hooks/useWidth';
import cn from 'classnames';
import s from './Viewer.scss';
const Viewer = ({ node })=>{
    var _node_extensionConfig;
    const attrs = node.attrs;
    const { alignment } = attrs;
    const config = (_node_extensionConfig = node.extensionConfig) === null || _node_extensionConfig === void 0 ? void 0 : _node_extensionConfig.gif;
    const align = alignment === 'left' ? s['left'] : alignment === 'right' ? s['right'] : s['center'];
    var _attrs_width, _config_smallMedia, _attrs_alignment;
    const { width, maxWidth } = useWidth((_attrs_width = attrs.width) !== null && _attrs_width !== void 0 ? _attrs_width : 780, config.defaultWidth, (_config_smallMedia = config.smallMedia) !== null && _config_smallMedia !== void 0 ? _config_smallMedia : false, (_attrs_alignment = attrs.alignment) !== null && _attrs_alignment !== void 0 ? _attrs_alignment : config.defaultAlignment, node.containerWidth);
    const newWidth = Math.min(maxWidth, width !== null && width !== void 0 ? width : config.defaultWidth);
    var _attrs_width1, _attrs_height;
    const height = newWidth / ((_attrs_width1 = attrs.width) !== null && _attrs_width1 !== void 0 ? _attrs_width1 : 0) * ((_attrs_height = attrs.height) !== null && _attrs_height !== void 0 ? _attrs_height : 0);
    const url = cleanLinkSrc((attrs === null || attrs === void 0 ? void 0 : attrs.url) || '', [
        'giphy.com'
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        "data-da-type": "da-gif",
        "data-width": attrs.width,
        "data-height": attrs.height,
        "data-alignment": attrs.alignment,
        "data-url": attrs.url,
        className: cn(s['gif-container'], align, (config === null || config === void 0 ? void 0 : config.smallMedia) && s['small-media'], s[`preset-${node.presetId}`])
    }, attrs && url && /*#__PURE__*/ React.createElement("video", {
        role: "img",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true // required for autoplay in iOS
        ,
        "aria-label": "gif",
        "data-da-type": EXTENSION_TYPE_NAME,
        width: newWidth,
        height: height,
        src: url,
        className: s['gif-video']
    }));
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map